import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

import { MonthlySalesChartTitle } from '../../../Constant';
import { H5 } from '../../../AbstractElements';
import { monthlySale } from '../../../Data/Widgets/Chart/ChartData';

const MonthlySalesChart = () => {
  return (
    <>
      <Col xl='5' lg='12' className='xl-50'>
        <div className='small-chart-widget chart-widgets-small'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{MonthlySalesChartTitle}</H5>
            </CardHeader>
            <CardBody>
              <div className='chart-container'>
                <Row>
                  <Col xs='12'>
                    <div id='chart-widget8'>
                      <ReactApexChart options={monthlySale.options} series={monthlySale.series} height='300' type='radar' />
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
    </>
  );
};
export default MonthlySalesChart;
